export const titleClass = {
  blue: 'productColumn__title--blue',
  gold: 'productColumn__title--gold',
  silver: 'productColumn__title--silver',
  silverLight: 'productColumn__title--silverLight',
  default: 'productColumn__title--none',
}
